import { useCallback, useEffect, useRef, useState } from "react";
import axios from "axios";

import Footer from "../layout/Footer";
import Navbar from "../layout/Navbar";

function Buddhism() {
  const isMounted = useRef(false);
  const [buddhismList, setBuddhismList] = useState([]);

  const fetchBuddhismListData = useCallback(async () => {
    try {
      const response = await axios.post("/api/website/getBuddhismList");
      setBuddhismList(response.data.data);
    } catch (error) {
      console.error("Error fetching article content:", error);
    }
  }, []);

  useEffect(() => {
    if (!isMounted.current) {
      isMounted.current = true;
      fetchBuddhismListData();
    }
  }, [fetchBuddhismListData]);

  return (
    <>
      <Navbar />
      <main>
        <section className="h-[250px] page-title flex justify-center items-center">
          <h2 className="text-[#3D3D3D] font-semibold text-5xl table:text-4xl mobile:text-3xl">
            公共佛堂
          </h2>
        </section>
        <section className="max-w-[800px] mx-auto">
          <div className="py-16 px-10 mobile:px-6 mobile:py-6">
            <ul className="[*&>:first-child]:pt-0">
              {buddhismList.map((item) => (
                <li key={item.id} className="py-5 border-b-[1px] border-b-gray-200 flex flex-col">
                  <h4 className="font-bold text-4xl mobile:text-2xl font-notoSerifTC text-[#3D3D3D]">
                    {item.name}
                  </h4>
                  <img
                    src={item.image}
                    alt="picture"
                    className="border-8 border-white shadow-2xl mt-4 mobile:mt-2"
                  />
                  <div className="flex justify-end mt-4 mobile:mt-2">
                    <a
                      href={`/buddhismIntro?id=${item.id}`}
                      className="text-xl px-6 py-3 rounded bg-yellow-400 mobile:w-full hover:bg-yellow-500 duration-200 cursor-pointer text-center"
                    >
                      查看佛堂資訊
                    </a>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}

export default Buddhism;
